import React, { useEffect, useState } from "react";
import { IAutomation } from "../../interfaces/IAutomation";
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { AutomationMailRow, getEmptyAutomationMail } from "./AutomationMailRow";
import { IRole } from "../../interfaces/IRole";
import { AutomationMailEdit } from "./AutomationMailEdit";

interface IProps {
    automation: IAutomation;
    setAutomation: Function;
    roleArray: IRole[];
}

export const AutomationMailCard: React.FC<IProps> = ({ automation, setAutomation, roleArray }) => {
    const [autoMailArray, setAutoMailArray] = useState(automation.AutomationMailArray);
    //
    const [isOpenNew, setIsOpenNew] = useState(false);
    const [newAutoMail, setNewAutoMail] = useState(
        getEmptyAutomationMail(automation.AutomationMailArray, automation.id),
    );

    const handleOpenNew = () => {
        setNewAutoMail(getEmptyAutomationMail(automation.AutomationMailArray, automation.id));
        setIsOpenNew(true);
    };
    const handleOnSave = () => {
        setAutoMailArray([...autoMailArray, newAutoMail]);
        setIsOpenNew(false);
    };

    useEffect(() => {
        setAutomation({
            ...automation,
            AutomationMailArray: [...autoMailArray],
        });
    }, [autoMailArray]);

    return (
        <>
            {isOpenNew && (
                <Dialog open onClose={() => setIsOpenNew(false)} maxWidth="md" fullWidth>
                    <DialogContent>
                        <AutomationMailEdit autoMail={newAutoMail} setAutoMail={setNewAutoMail} roleArray={roleArray} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenNew(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleOnSave}>
                            Übernehmen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <Card variant="outlined">
                <CardContent>
                    <Typography>
                        Automatische E-Mails
                        <Button sx={{ float: "right" }} variant="outlined" onClick={handleOpenNew}>
                            Hinzufügen
                        </Button>
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Titel</TableCell>
                                <TableCell>Betreff</TableCell>
                                <TableCell>Edit.</TableCell>
                                <TableCell>An (Rollen)</TableCell>
                                <TableCell width={100}>Aktionen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {automation.AutomationMailArray.map((auto) => (
                                <AutomationMailRow
                                    key={`auto-mail-${auto.id}`}
                                    autoMail={auto}
                                    autoMailArray={autoMailArray}
                                    setAutoMailArray={setAutoMailArray}
                                    roleArray={roleArray}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </>
    );
};
